import { Component, computed, inject, input, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { AdmDepTypeaheadComponent } from 'src/app/shared/components/adm-dep-typeahead/adm-dep-typeahead.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Department } from 'src/app/features/department/department.model';
import { AdmOrgTypeaheadComponent } from 'src/app/shared/components/adm-org-typeahead/adm-org-typeahead.component';
import { Organization } from 'src/app/features/organization/organization-models';
import { TranslateLocationCategoryEnum } from '../../../../../shared/pipes/translate-location-category-enum.pipe';
import { EnumToArrayPipe } from '../../../../../shared/pipes/enum-to-array.pipe';
import { LocationCategory } from '../../../charging-station-location-model';
import { MatOption, MatSelect, MatSuffix } from '@angular/material/select';
import { ChargingStationLocationCreatedEditDialogService } from '../../charging-station-location-created-edit-dialog.service';
import { MatIcon } from '@angular/material/icon';
import { CustomDropDownArrowDirective } from 'ok-angular-shared/directives';

export interface Step1Form {
  organizationId: FormControl<number | null>;
  departmentId: FormControl<string | null>;
  category: FormControl<LocationCategory>;
}

@Component({
  selector: 'adm-csl-step1',
  imports: [
    AdmOrgTypeaheadComponent,
    AdmDepTypeaheadComponent,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    TranslateLocationCategoryEnum,
    EnumToArrayPipe,
    MatSelect,
    MatOption,
    MatSuffix,
    MatIcon,
    CustomDropDownArrowDirective,
  ],
  templateUrl: './step1.component.html',
  styleUrl: './step1.component.scss',
})
export class ChargingStationLocationEditDialogStep1Component {
  form = input.required<FormGroup<Step1Form>>();
  service = inject(ChargingStationLocationCreatedEditDialogService);

  resetOrgTrigger = signal<{ reset: boolean }>({ reset: false });
  resetDepTrigger = signal<{ reset: boolean }>({ reset: false });
  categories = LocationCategory;

  readonly isPrePopulated = computed(() => !this.service.isEditing() && this.service.dialogData?.organizationId != null);

  public resetOrganization() {
    this.resetDepTrigger.set({ reset: true });
    this.form().patchValue({
      organizationId: null,
      departmentId: null,
    });
  }

  public resetDepartment() {
    this.resetDepTrigger.set({ reset: true });
    this.form().patchValue({
      departmentId: null,
    });
  }

  public onDepartmentSelected(department: Department | null): void {
    this.form().controls.departmentId.patchValue(department?.id.toString() ?? null);
  }

  organizationSelected = (org?: Organization) => {
    const nextOrganizationId = org?.id ?? null;
    const organizationIdControl = this.form().controls.organizationId;

    if (organizationIdControl.value === nextOrganizationId) {
      return;
    }

    organizationIdControl.patchValue(nextOrganizationId);
    organizationIdControl.markAsDirty();
    organizationIdControl.updateValueAndValidity();

    this.resetDepartment();
    this.service.organizationChanged.next(nextOrganizationId);
  };
}
